import { StatusCodes } from 'http-status-codes';
import React, { useEffect, useState } from 'react';
import { QuantityGetDto, ResultDto } from 'svila-common';
import { useHistory } from 'react-router-dom';

import DisplayQuantities from '~/src/components/common/DisplayQuantities';
import ButtonComponent from '~/src/components/common/forms/Button/ButtonComponent';
import TitleComponent from '~/src/components/common/forms/Title/TitleComponent';
import WhitePad from '~/src/components/common/WhitePad/WhitePad';
import FnbApi from '~/src/services/api/FnbApi';
import ImportResults from '../../imports/components/ResultDtoDisplay';
import PrimaryButton from '~/src/components/common/forms/Button/PrimaryButton';

export default function FnbHangingOrders(): JSX.Element {
  const history = useHistory();

  const [loading, setLoading] = useState<boolean>(false);
  const [result, setProducts] = useState<ResultDto | null>(null);

  const getMatchings = async (): Promise<void> => {
    setLoading(true);
    const res = await FnbApi.getProblematicConsolidations();
    if (res.status === StatusCodes.OK) {
      setProducts(res.data);
    }
    setLoading(false);
  };

  return (
    <WhitePad>
      <TitleComponent
        title="Hanging orders and their quantities"
        onLeftHandler={() => {
          history.push(`/data-operations`);
        }}
      />
      <PrimaryButton title="Get" onClick={getMatchings} isSubmitting={loading} />
      {result && <ImportResults result={result} />}
    </WhitePad>
  );
}
